module.exports = __webpack_public_path__ + "assets/icons/ic_check-9f9e.svg";